'use client';

import Link from 'next/link';

import { Button } from '@eliadmin/core/src/components/ui/button';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useBreakpoint } from '@eliadmin/core/src/hooks/use-breakpoint';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

import { AiOutlineCloseCircle } from 'react-icons/ai';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Heading } from '@eliadmin/core/src/components/ui/heading';
import { MdOutlinePhoneInTalk } from 'react-icons/md';

export function CartHeader() {
  const { t } = useTranslations();

  const isDesktop = useBreakpoint('sm');

  return (
    <header className={cn('custom-section', 'py-3 sm:py-4 lg:py-6', 'ea-cart-header')}>
      <div className={cn('custom-container', 'flex items-center justify-between gap-4')}>
        <div className="flex flex-1 items-center justify-start">
          <Button asChild size={isDesktop ? 'default' : 'icon-lg'} variant={'primary-foreground'}>
            <Link prefetch={false} href={ROUTES.HOME()}>
              <AiOutlineCloseCircle size={isDesktop ? 20 : 18} />
              {isDesktop && t('text3703')}
            </Link>
          </Button>
        </div>

        <Heading title={t('text63')} tag="h3" center />
        <div className="hidden flex-1 items-center justify-end gap-2 sm:flex">
          {t('text3438')}{' '}
          <Link
            prefetch={false}
            target="_blank"
            href={'tel:+0800123456'}
            className="h6 font-semibold text-primary"
          >
            +0800 123 456
          </Link>
        </div>
        <div className="flex w-full flex-1 items-center justify-end sm:hidden">
          <Link
            prefetch={false}
            target="_blank"
            href={'tel:+0800123456'}
            className="h6 font-semibold text-[#117F11]"
          >
            <MdOutlinePhoneInTalk size={24} />
          </Link>
        </div>
      </div>
    </header>
  );
}
